/**
 * Celluma Product Comparison — Custom Element
 *
 * Usage: <product-comparison></product-comparison>
 * Reads window.cellumaConfig (products, dynamicRows, variantDisplayMode).
 *
 * URL param support:
 *   ?compare=variantId1,variantId2,variantId3
 *   - Reads on load to pre-select columns.
 *   - Updates automatically as the user changes selections.
 *   - Empty slots are represented by a "0" placeholder so indices stay stable.
 *   e.g. ?compare=53184533692781,,51878093881709   → col 0 & col 2 set, col 1 empty
 */
if (!window.__celluma_comparison_loaded) {
window.__celluma_comparison_loaded = true;

/* ─────────────────────────────────────────────
  Constants
───────────────────────────────────────────── */
const PLACEHOLDER_IMAGE =
  'https://cdn.shopify.com/s/files/1/0116/2710/2265/files/celluma-placeholder.png';
const LS_KEY = 'celluma-product-comparison-selections';
const PARAM = 'compare';
const CHECKMARK_SVG = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Yes"><rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="white"/><rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="black"/><path d="M14.0435 19.5L13.2776 20.143L13.9813 20.9812L14.7528 20.2049L14.0435 19.5ZM21.7093 13.2049L22.4142 12.4956L20.9956 11.0858L20.2907 11.7951L21 12.5L21.7093 13.2049ZM11 15.875L10.2341 16.518L13.2776 20.143L14.0435 19.5L14.8093 18.857L11.7659 15.232L11 15.875ZM14.0435 19.5L14.7528 20.2049L21.7093 13.2049L21 12.5L20.2907 11.7951L13.3342 18.7951L14.0435 19.5Z" fill="black"/></svg>`;
const VECTOR_SVG = `<svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Remove"><path d="M9.75 0.75L0.75 9.75M9.75 9.75L0.75 0.75" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const CHEVRON_SVG = `<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.6001 4.6001L4.6001 0.600098L0.600098 4.6001" stroke="black" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const styles = `
  :host {
    margin-block-end: 0 !important;
    margin-block-start: 0 !important;
  }
  .afterpay-paragraph {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
  }
  .afterpay-logo.brand-afterpay {
    min-width: 83px;
    width: 83px;
  }
  .afterpay-logo.logo-cashappafterpay {
    background-image: url('${window.afterpayLogo}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-flex;
    height: 16px;
    min-height: 16px;
  }
  .afterpay-logo.logo-cashappafterpay svg {
    display: none;
  }
  .cashappafterpay-with-word-pay-monthly,
  .afterpay-link,
  #logo-link {
    display: none !important;
  }
`;

/* ─────────────────────────────────────────────
  Fallback demo products
───────────────────────────────────────────── */
const FALLBACK_PRODUCTS = [{"productId":"pod-001","variantId":"pod-v1","title":"Celluma POD","price":{"amount":49900,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_POD.jpg?v=1756858031","url":"/products/pod","availableQuantity":50,"variants":[{"id":"pod-v1","title":"Celluma POD","price":49900,"available":true,"sku":"pod-001","inventory_quantity":50,"options":["Default Title"],"description":""}]},{"productId":"home-001","variantId":"home-v1","title":"Celluma HOME","price":{"amount":79500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_HOME.jpg?v=1756858031","url":"/products/home","availableQuantity":45,"variants":[{"id":"home-v1","title":"Celluma HOME","price":79500,"available":true,"sku":"home-001","inventory_quantity":45,"options":["Default Title"],"description":""}]},{"productId":"face-001","variantId":"face-v1","title":"Celluma FACE","price":{"amount":79500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_FACE.jpg?v=1756858031","url":"/products/face","availableQuantity":40,"variants":[{"id":"face-v1","title":"Celluma FACE","price":79500,"available":true,"sku":"face-001","inventory_quantity":40,"options":["Default Title"],"description":""}]},{"productId":"lite-001","variantId":"lite-v1","title":"Celluma LITE","price":{"amount":119500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_LITE.jpg?v=1756858031","url":"/products/lite","availableQuantity":35,"variants":[{"id":"lite-v1","title":"Celluma LITE","price":119500,"available":true,"sku":"lite-001","inventory_quantity":35,"options":["Default Title"],"description":""}]},{"productId":"restore-001","variantId":"restore-v1","title":"Celluma RESTORE","price":{"amount":119500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_RESTORE.jpg?v=1756858031","url":"/products/restore","availableQuantity":30,"variants":[{"id":"restore-v1","title":"Celluma RESTORE","price":119500,"available":true,"sku":"restore-001","inventory_quantity":30,"options":["Default Title"],"description":""}]},{"productId":"nova-001","variantId":"nova-v1","title":"Celluma NOVA","price":{"amount":159500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_NOVA.jpg?v=1756858031","url":"/products/nova","availableQuantity":25,"variants":[{"id":"nova-v1","title":"Celluma NOVA","price":159500,"available":true,"sku":"nova-001","inventory_quantity":25,"options":["Default Title"],"description":""}]},{"productId":"sport-001","variantId":"sport-v1","title":"Celluma SPORT","price":{"amount":129500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_SPORT.jpg?v=1756858031","url":"/products/sport","availableQuantity":30,"variants":[{"id":"sport-v1","title":"Celluma SPORT","price":129500,"available":true,"sku":"sport-001","inventory_quantity":30,"options":["Default Title"],"description":""}]},{"productId":"pro-001","variantId":"pro-v1","title":"Celluma PRO","price":{"amount":179500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_PRO.jpg?v=1756858031","url":"/products/pro","availableQuantity":20,"variants":[{"id":"pro-v1","title":"Celluma PRO","price":179500,"available":true,"sku":"pro-001","inventory_quantity":20,"options":["Default Title"],"description":""}]},{"productId":"pro-plus-001","variantId":"pro-plus-v1","title":"Celluma PRO Plus","price":{"amount":199500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_PRO_PLUS.jpg?v=1756858031","url":"/products/pro-plus","availableQuantity":15,"variants":[{"id":"pro-plus-v1","title":"Celluma PRO Plus","price":199500,"available":true,"sku":"pro-plus-001","inventory_quantity":15,"options":["Default Title"],"description":""}]},{"productId":"contour-001","variantId":"contour-v1","title":"Celluma CONTOUR","price":{"amount":449500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_CONTOUR.jpg?v=1756858031","url":"/products/contour","availableQuantity":10,"variants":[{"id":"contour-v1","title":"Celluma CONTOUR","price":449500,"available":true,"sku":"contour-001","inventory_quantity":10,"options":["Default Title"],"description":""}]},{"productId":"cntr-plus-001","variantId":"cntr-plus-v1","title":"Celluma CNTR PLUS","price":{"amount":499500,"currency":"USD"},"image":"","url":"/products/cntr-plus","availableQuantity":8,"variants":[{"id":"cntr-plus-v1","title":"Celluma CNTR PLUS","price":499500,"available":true,"sku":"cntr-plus-001","inventory_quantity":8,"options":["Default Title"],"description":""}]},{"productId":"elite-001","variantId":"elite-v1","title":"Celluma Elite","price":{"amount":599500,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_ELITE.jpg?v=1756858031","url":"/products/elite","availableQuantity":5,"variants":[{"id":"elite-system","title":"Elite System","price":599500,"available":true,"sku":"elite-sys","inventory_quantity":8,"options":["Elite System"],"description":"3 Panels"},{"id":"elite-base","title":"Elite Base","price":499500,"available":true,"sku":"elite-base","inventory_quantity":12,"options":["Elite Base"],"description":"Single Panel"}]},{"productId":"delux-xl-001","variantId":"delux-xl-v1","title":"Celluma Delux S2","price":{"amount":1250000,"currency":"USD"},"image":"https://cdn.shopify.com/s/files/1/0116/2710/2265/files/Celluma_DELUX.jpg?v=1756858031","url":"/products/delux-xl","availableQuantity":3,"variants":[{"id":"delux-regular","title":"Regular","price":1250000,"available":true,"sku":"delux-reg","inventory_quantity":10,"options":["Regular"],"description":"Standard size coverage"},{"id":"delux-xl","title":"XL","price":1350000,"available":true,"sku":"delux-xl","inventory_quantity":5,"options":["XL"],"description":"Extra large coverage"}]}];

/* ─────────────────────────────────────────────
  Config loader
───────────────────────────────────────────── */
function stripBrandFromTitle(title) {
  return String(title || '')
    .replace(/celluma/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizeProductTitles(products) {
  return products.map(p => {
    const isSingleVariant = !Array.isArray(p.variants) || p.variants.length <= 1;
    return isSingleVariant ? { ...p, title: stripBrandFromTitle(p.title) } : p;
  });
}

function loadConfig() {
  const cfg = window.cellumaConfig;
  if (!cfg || !Array.isArray(cfg.products) || cfg.products.length === 0) {
    console.warn('⚠️ [Celluma Config] No valid cellumaConfig found — using fallback products');
    return { products: normalizeProductTitles(FALLBACK_PRODUCTS), dynamicRows: [], variantDisplayMode: 'as_product' };
  }
  const valid = cfg.products.filter(p =>
    p && typeof p.productId === 'string' && typeof p.title === 'string' &&
    p.price && typeof p.price.amount === 'number'
  );
  if (valid.length === 0) {
    console.warn('⚠️ [Celluma Config] All products invalid — using fallback');
    return { products: normalizeProductTitles(FALLBACK_PRODUCTS), dynamicRows: [], variantDisplayMode: 'as_product' };
  }
  console.log(`✅ [Celluma Config] Loaded ${valid.length} products`);
  return {
    products: normalizeProductTitles(valid),
    dynamicRows: cfg.dynamicRows || [],
    variantDisplayMode: cfg.variantDisplayMode || 'as_product',
  };
}

/* ─────────────────────────────────────────────
  Helpers
───────────────────────────────────────────── */
function formatPrice(cents, currency) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency', currency,
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(cents / 100);
}

function resolveImage(product, variantId) {
  if (!product) return PLACEHOLDER_IMAGE;
  if (variantId) {
    const v = product.variants?.find(v => v.id === variantId);
    if (v?.image && v.image.trim() !== '') return v.image;
  }
  return product.image && product.image.trim() !== '' ? product.image : PLACEHOLDER_IMAGE;
}

function el(tag, attrs = {}, ...children) {
  const node = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'className') node.className = v;
    else if (k === 'innerHTML') node.innerHTML = v;
    else if (k.startsWith('on')) node.addEventListener(k.slice(2).toLowerCase(), v);
    else node.setAttribute(k, v);
  }
  for (const child of children) {
    if (child == null) continue;
    node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
  }
  return node;
}

/* ─────────────────────────────────────────────
  URL param helpers
───────────────────────────────────────────── */
/**
  * Read ?compare=variantId1,variantId2,variantId3 from the URL.
  * Returns an array of exactly 3 entries; null for empty/missing slots.
  */
function readUrlParams() {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get(PARAM);
  if (!raw) return [null, null, null];
  const parts = raw.split(',').slice(0, 3);
  while (parts.length < 3) parts.push('');
  return parts.map(p => (p && p.trim() && p.trim() !== '0' ? p.trim() : null));
}

/**
  * Write current variant selections back to the URL without reloading.
  * Empty slots become '0' so the comma-delimited positions stay stable.
  */
function writeUrlParams(variantIds) {
  const serialized = variantIds.map(v => (v != null ? String(v) : '0')).join(',');
  const url = new URL(window.location.href);
  if (url.searchParams.get(PARAM) === serialized) return;
  url.searchParams.set(PARAM, serialized);
  window.history.replaceState(null, '', url.toString());
}

/* ─────────────────────────────────────────────
  Custom <select> widget
───────────────────────────────────────────── */
function createCustomSelect({ value, options, onChange, placeholder = 'Select' }) {
  let isOpen = false;
  let currentValue = value;

  const container = el('div', { className: 'custom-select-container' });

  const trigger = el('div', {
    className: 'custom-select-trigger',
    role: 'button',
    tabindex: '0',
  });

  const optionsEl = el('div', { className: 'custom-select-options' });

  function updateTriggerLabel() {
    const found = options.find(o => o.value === currentValue);
    trigger.textContent = found ? found.label : placeholder;
  }

  function buildOptions() {
    optionsEl.innerHTML = '';
    const placeholderOpt = el('div', {
      className: `custom-select-option${currentValue === '' ? ' selected' : ''}`,
      onClick() { pick(''); },
    }, placeholder);
    optionsEl.appendChild(placeholderOpt);

    for (const opt of options) {
      const optEl = el('div', {
        className: `custom-select-option${opt.value === currentValue ? ' selected' : ''}`,
        onClick() { pick(opt.value); },
      }, opt.label);
      optionsEl.appendChild(optEl);
    }
  }

  function pick(val) {
    currentValue = val;
    isOpen = false;
    updateTriggerLabel();
    optionsEl.style.display = 'none';
    onChange(val);
  }

  function toggle() {
    isOpen = !isOpen;
    if (isOpen) {
      buildOptions();
      optionsEl.style.display = 'block';
    } else {
      optionsEl.style.display = 'none';
    }
  }

  trigger.addEventListener('click', toggle);
  trigger.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') toggle(); });

  document.addEventListener('mousedown', e => {
    if (!container.contains(e.target)) {
      isOpen = false;
      optionsEl.style.display = 'none';
    }
  });

  optionsEl.style.display = 'none';
  updateTriggerLabel();
  container.appendChild(trigger);
  container.appendChild(optionsEl);

  container._setValue = function (val) {
    currentValue = val;
    updateTriggerLabel();
  };

  return container;
}

/* ─────────────────────────────────────────────
  Row icon renderer
───────────────────────────────────────────── */
function renderRowIcon(icon) {
  if (!icon) return null;
  if (typeof icon === 'string') {
    const img = el('img', { src: icon, alt: 'row icon', className: 'row-icon-image' });
    return img;
  }
  return document.createTextNode(String(icon));
}

function pushAddToCartEvent(item) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'add_to_cart',
    add_to_cart_source: 'compare_chart',
    ecommerce: {
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      value: ((item.final_price ?? item.price ?? 0) / 100) * (item.quantity || 1),
      items: [{
        item_id: String(item.variant_id ?? item.id ?? ''),
        item_name: item.product_title || item.title || '',
        item_variant: item.variant_title || '',
        item_brand: item.vendor || '',
        price: (item.final_price ?? item.price ?? 0) / 100,
        quantity: item.quantity || 1,
        item_list_id: 'product_comparison',
        item_list_name: 'Compare Products',
      }],
    },
  });
}

/* ─────────────────────────────────────────────
  Build row definitions
───────────────────────────────────────────── */
function buildCta(product, variantId, showReviewSummary = false) {
  const variant = product.variants?.find(v => v.id === variantId) || product.variants?.[0];
  const vid = variant ? variant.id : product.variantId;
  const available = variant ? variant.available : true;
  const soldOutText = (window.theme && window.theme.strings && window.theme.strings.soldOut) || 'Sold Out';
  const div = el('div', { className: 'cta-container' });

  if (showReviewSummary) {
    div.appendChild(el('div', {
      className: 'jdgm-widget jdgm-preview-badge',
      'data-id': String(product.productId || ''),
      style: 'min-height: 23px;',
      innerHTML: product.judgemeBadge || '',
    }));
  }

  const form = el('form', { action: '/cart/add', method: 'post' });
  form.appendChild(el('input', { type: 'hidden', name: 'id', value: String(vid) }));
  const btnAttrs = { type: 'submit', className: 'add-to-cart-btn', 'data-add-to-cart': '' };
  if (!available) btnAttrs.disabled = 'disabled';
  const atcBtn = el('button', btnAttrs, available ? 'Add to cart' : soldOutText);
  form.appendChild(atcBtn);
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      if (!item.status) pushAddToCartEvent(item);

      if (window.Rebuy && window.Rebuy.SmartCart) {
        window.Rebuy.SmartCart.show();
      } else {
        document.addEventListener('rebuy:smartcart:ready', () => {
          window.Rebuy.SmartCart.show();
        });
      }
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });
  });
  div.appendChild(form);
  div.appendChild(el('a', { className: 'learn-more-link', href: product.url }, 'Learn more'));
  return div;
}

function buildRows(dynamicRows) {
  let pastFirstTitleRow = false;
  return dynamicRows.map(row => {
    if (row.blockType === 'title_row') {
      pastFirstTitleRow = true;
      return {
        blockType: 'title_row',
        title: row.title,
        largerFontMobile: !!row.largerFontMobile,
      };
    }

    if (row.blockType === 'price_row') {
      const showAfterpayPrice = !!row.showAfterpayPrice;
      return {
        blockType: 'price_row',
        key: 'price',
        title: 'Price',
        icon: row.icon || null,
        isPreTitle: !pastFirstTitleRow,
        showIconMobile: row.showIconMobile !== false,
        largerFontMobile: !!row.largerFontMobile,
        getValue(product, variantId) {
          const variant = product.variants?.find(v => v.id === variantId) || product.variants?.[0];
          const amount = variant ? variant.price : product.price.amount;
          const priceWrapper = el('div', { className: 'price-wrapper' });
          const price = el('span');
          price.innerHTML = formatPrice(amount, product.price.currency);
          priceWrapper.appendChild(price);

          if (showAfterpayPrice) {
            const apPlacement = el('afterpay-placement', {
              'data-amount': amount / 100,
              'data-currency': product.price.currency,
              'data-logo-type': 'lockup',
              'data-lockup-theme': 'black',
              'data-size': 'xs',
              'data-MPID': afterpay_shop_permanent_domain
            });
            priceWrapper.appendChild(apPlacement);
          }

          return priceWrapper;
        },
      };
    }

    const shouldClamp = pastFirstTitleRow;
    return {
      blockType: 'comparison_row',
      key: row.key,
      title: row.title,
      icon: row.icon || null,
      isPreTitle: !pastFirstTitleRow,
      showIconMobile: row.showIconMobile !== false,
      largerFontMobile: !!row.largerFontMobile,
      getValue(product, variantId) {
        const variant = product.variants?.find(v => v.id === variantId) || product.variants?.[0];
        const val = variant?.metafields?.[row.key];
        if (!val) return document.createTextNode('--');
        if (row.type === 'boolean') {
          if (val === true || val === 'true') {
            const span = el('span', { style: 'display:flex;justify-content:center;align-items:center' });
            span.innerHTML = CHECKMARK_SVG;
            return span;
          }
          return document.createTextNode('--');
        }
        if (row.type === 'metaobject') {
          const span = el('span', { style: 'display:flex;flex-direction:column;justify-content:center;align-items:center;gap:4px' });
          if (val.icon) {
            const img = el('img', { src: val.icon, alt: row.title, className: 'row-icon-image', style: 'width:24px;height:24px' });
            span.appendChild(img);
          }
          span.appendChild(document.createTextNode(val.text || '--'));
          return span;
        }
        if (!shouldClamp) return document.createTextNode(val);
        return buildClampedText(val, row.key);
      },
    };
  });
}

let clampIdCounter = 0;

function buildClampedText(text, rowKey) {
  clampIdCounter += 1;
  const contentId = `clamp-text-${rowKey}-${clampIdCounter}`;

  const wrapper = el('div', { className: 'clamped-text-wrapper' });
  const textEl = el('p', { className: 'clamped-text', id: contentId }, text);
  wrapper.appendChild(textEl);

  const toggleBtn = el('button', {
    type: 'button',
    className: 'clamp-toggle-btn',
    'aria-expanded': 'false',
    'aria-controls': contentId,
  });
  const label = el('span', { className: 'clamp-toggle-label' }, 'More');
  const chevron = el('span', { className: 'clamp-toggle-chevron', 'aria-hidden': 'true', innerHTML: CHEVRON_SVG });
  toggleBtn.appendChild(label);
  toggleBtn.appendChild(chevron);
  toggleBtn.style.display = 'none';
  toggleBtn.addEventListener('click', () => {
    const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
    toggleBtn.setAttribute('aria-expanded', String(!expanded));
    textEl.classList.toggle('is-expanded', !expanded);
    toggleBtn.classList.toggle('is-expanded', !expanded);
    label.textContent = expanded ? 'More' : 'Less';
  });
  wrapper.appendChild(toggleBtn);

  requestAnimationFrame(() => {
    if (textEl.scrollHeight > textEl.clientHeight + 1) {
      toggleBtn.style.display = '';
    }
  });

  return wrapper;
}

/* ─────────────────────────────────────────────
  Expand variants-as-products
───────────────────────────────────────────── */
function flattenProducts(products) {
  const flat = [];
  for (const p of products) {
    if (p.variants && p.variants.length > 1) {
      for (const v of p.variants) {
        flat.push({
          ...p,
          variantId: v.id,
          title: v.title,
          price: { amount: v.price, currency: p.price.currency },
          availableQuantity: v.inventory_quantity,
          image: v.image || p.image,
          variants: [v],
        });
      }
    } else {
      flat.push(p);
    }
  }
  return flat;
}

/* ─────────────────────────────────────────────
  Inject Afterpay shadow DOM styles
───────────────────────────────────────────── */
const styledAfterpayElements = new WeakSet();

const afterpayStyles = (root) => {
  if (styledAfterpayElements.has(root)) return;
  const shadow = root.shadowRoot;
  if (!shadow) return;
  const extraSheet = new CSSStyleSheet();
  extraSheet.replaceSync(styles);
  shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, extraSheet];
  styledAfterpayElements.add(root);
}

const observeAfterpayElements = () => {
  const applyToExisting = () => {
    document.querySelectorAll('afterpay-placement').forEach(afterpayStyles);
  };
  applyToExisting();
  const observer = new MutationObserver(applyToExisting);
  observer.observe(document.body, { childList: true, subtree: true });
}
observeAfterpayElements();

/* ─────────────────────────────────────────────
  Main App
───────────────────────────────────────────── */
class ProductComparison extends HTMLElement {
  connectedCallback() {
    const mountEl = this;
    const { products: rawProducts, dynamicRows, variantDisplayMode } = loadConfig();
    const showReviewSummary = mountEl.dataset.showReviewSummary === "true";
    const rows = buildRows(dynamicRows);

    const isAsProduct = variantDisplayMode === 'as_product';
    const flatProducts = isAsProduct ? flattenProducts(rawProducts) : null;

    let stickyScrollHandler = null;
    let stickyScrollTarget = null;

    /* ── State ── */
    const selectedProducts = [null, null, null];
    const selectedVariants = [null, null, null];
    const selectedFlatProducts = [null, null, null];

    /* ── Initialise from URL params, then fall back to localStorage ── */
    function initFromUrlOrStorage() {
      const attrCompare = mountEl.dataset.compare;
      const attrVariantIds = attrCompare
        ? attrCompare.split(',').map(v => v.trim() || null)
        : null;

      const urlVariantIds = attrVariantIds || readUrlParams();
      const hasUrlParams = urlVariantIds.some(v => v !== null);

      if (isAsProduct) {
        if (hasUrlParams) {
          urlVariantIds.forEach((vid, i) => {
            if (!vid) return;
            const found = flatProducts.find(p => String(p.variantId) === String(vid));
            if (found) selectedFlatProducts[i] = found;
          });
        }
      } else {
        if (hasUrlParams) {
          urlVariantIds.forEach((vid, i) => {
            if (!vid) return;
            const prod = rawProducts.find(p => p.variants?.some(v => String(v.id) === String(vid)));
            if (prod) {
              selectedProducts[i] = prod;
              const matchedVariant = prod.variants.find(v => String(v.id) === String(vid));
              selectedVariants[i] = matchedVariant ? matchedVariant.id : prod.variants[0]?.id;
            }
          });
        } else {
          try {
            const stored = localStorage.getItem(LS_KEY);
            if (stored) {
              const parsed = JSON.parse(stored);
              if (Array.isArray(parsed) && parsed.length === 3) {
                parsed.forEach((entry, i) => {
                  if (!entry?.productId) return;
                  const prod = rawProducts.find(p => p.productId === entry.productId);
                  if (!prod) return;
                  selectedProducts[i] = prod;
                  const validVariant = prod.variants?.some(v => v.id === entry.variantId);
                  selectedVariants[i] = validVariant ? entry.variantId : prod.variants?.[0]?.id;
                });
              }
            }
          } catch (e) {
            console.error('Failed to restore saved selections:', e);
          }
        }
      }
    }

    /* ── Persist selections ── */
    function persistState() {
      const variantIds = isAsProduct
        ? selectedFlatProducts.map(p => p?.variantId || null)
        : selectedVariants.slice();

      if (!mountEl.dataset.compare) {
        writeUrlParams(variantIds);
      }

      if (!isAsProduct && selectedProducts.some(p => p !== null)) {
        const toSave = selectedProducts.map((p, i) => p
          ? { productId: p.productId, variantId: selectedVariants[i] }
          : null
        );
        localStorage.setItem(LS_KEY, JSON.stringify(toSave));
      }
    }

    /* ── Render ── */
    function columnCount() {
      return window.matchMedia('(max-width: 768px)').matches ? 2 : 3;
    }

    function equalizeHeaderHeights() {
      const contents = mountEl.querySelectorAll('.product-header-content');
      if (!contents.length) return;
      contents.forEach(el => { el.style.height = 'auto'; });
      let max = 0;
      contents.forEach(el => { max = Math.max(max, el.offsetHeight); });
      contents.forEach(el => { el.style.height = `${max}px`; });
    }

    function setupStickySelects() {
      if (stickyScrollHandler && stickyScrollTarget) {
        stickyScrollTarget.removeEventListener('scroll', stickyScrollHandler);
        stickyScrollHandler = null;
        stickyScrollTarget = null;
      }

      const selectContainers = Array.from(
        mountEl.querySelectorAll('.product-header-content > .custom-select-container, .product-header-content > .product-selector-container')
      );
      if (!selectContainers.length) return;

      const stickyBar = el('div', { className: 'sticky-select-bar' });
      const stickyBarTrack = el('div', { className: 'sticky-select-bar__track' });
      stickyBar.appendChild(stickyBarTrack);
      const comparisonTable = mountEl.querySelector('.prod-comparison-table');
      (comparisonTable || mountEl).appendChild(stickyBar);

      const scrollTarget = mountEl.closest('.compare-modal__drawer') || window;

      function makePlaceholder(target) {
        const rect = target.getBoundingClientRect();
        const placeholder = el('div', { className: 'select-placeholder' });
        placeholder.style.width = `${rect.width}px`;
        placeholder.style.height = `${rect.height}px`;
        placeholder.style.display = 'none';
        target.parentNode.insertBefore(placeholder, target);
        return placeholder;
      }

      const columns = selectContainers.map(select => {
        const headerContent = select.parentElement;
        const form = headerContent ? headerContent.querySelector(':scope > .cta-container > form') : null;
        return {
          select,
          selectPlaceholder: makePlaceholder(select),
          form,
          formPlaceholder: form ? makePlaceholder(form) : null,
          group: el('div', { className: 'sticky-select-bar__column' }),
        };
      });

      let isStuck = false;
      let ticking = false;

      function stick() {
        if (isStuck) return;
        isStuck = true;
        if (scrollTarget !== window) {
          stickyBar.style.top = `${scrollTarget.getBoundingClientRect().top}px`;
        }
        columns.forEach(col => {
          col.selectPlaceholder.style.display = 'block';
          col.group.appendChild(col.select);
          if (col.form) {
            col.formPlaceholder.style.display = 'block';
            col.group.appendChild(col.form);
          }
          stickyBarTrack.appendChild(col.group);
        });
        stickyBar.classList.add('is-visible');
      }

      function unstick() {
        if (!isStuck) return;
        isStuck = false;
        columns.forEach(col => {
          col.selectPlaceholder.parentNode.insertBefore(col.select, col.selectPlaceholder);
          col.selectPlaceholder.style.display = 'none';
          if (col.form) {
            col.formPlaceholder.parentNode.insertBefore(col.form, col.formPlaceholder);
            col.formPlaceholder.style.display = 'none';
          }
        });
        stickyBar.classList.remove('is-visible');
      }

      function checkScroll() {
        ticking = false;
        const threshold = scrollTarget === window ? 0 : scrollTarget.getBoundingClientRect().top;
        if (!isStuck) {
          if (columns[0].select.getBoundingClientRect().top < threshold) stick();
        } else {
          if (columns[0].selectPlaceholder.getBoundingClientRect().top >= threshold) unstick();
        }
      }

      stickyScrollHandler = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(checkScroll);
      };
      stickyScrollTarget = scrollTarget;

      scrollTarget.addEventListener('scroll', stickyScrollHandler, { passive: true });
      checkScroll();
    }

    function revealJudgeMeBadges() {
      mountEl.querySelectorAll('.jdgm-preview-badge .jdgm-prev-badge').forEach(badge => {
        badge.style.setProperty('display', 'flex', 'important');
        badge.style.setProperty('align-items', 'center', 'important');
        badge.style.setProperty('visibility', 'visible', 'important');
        badge.closest('.jdgm-preview-badge')?.classList.add('jdgm--done-setup');

        const rating = parseFloat(badge.dataset.averageRating);
        const textEl = badge.querySelector('.jdgm-prev-badge__text');
        if (textEl && !Number.isNaN(rating)) {
          textEl.textContent = rating.toFixed(1);
          textEl.style.setProperty('display', 'inline-block', 'important');
          textEl.style.setProperty('visibility', 'visible', 'important');
        }
      });
    }

    function render() {
      mountEl.innerHTML = '';
      if (isAsProduct) {
        mountEl.appendChild(renderAsProductTable());
      } else {
        mountEl.appendChild(renderSelectorTable());
      }
      equalizeHeaderHeights();
      setupStickySelects();
      if (showReviewSummary) revealJudgeMeBadges();
    }

    /* ═══════════════════════════════════════════
      AS-PRODUCT mode (variant columns fixed)
    ═══════════════════════════════════════════ */
    function getAvailableFlatOptions(slotIndex) {
      return flatProducts.filter(p =>
        !selectedFlatProducts.some((sel, i) =>
          i !== slotIndex && sel && sel.productId === p.productId && sel.variantId === p.variantId
        )
      );
    }

    function selectFlatProduct(compositeVal, slotIndex) {
      if (!compositeVal) {
        selectedFlatProducts[slotIndex] = null;
      } else {
        const [pid, vid] = compositeVal.split('|||');
        selectedFlatProducts[slotIndex] = flatProducts.find(
          p => p.productId === pid && p.variantId === vid
        ) || null;
      }
      persistState();
      render();
    }

    function isNodeEmpty(val) {
      if (!val) return true;
      if (val instanceof Node) {
        const text = val.textContent.trim();
        return text === '' && val.childNodes.length === 0;
      }
      return String(val).trim() === '';
    }

    function buildTbody(getProductAndVariant) {
      const cols = columnCount();
      const allSelected = Array.from({ length: cols }, (_, i) => getProductAndVariant(i).product)
        .every(p => p != null);

      const tbody = el('tbody', { role: 'rowgroup' });
      for (const row of rows) {
        if (row.blockType === 'title_row') {
          const titleTr = el('tr', { className: 'comparison-title-row', role: 'row' });
          const titleCellClassName = row.largerFontMobile
            ? 'comparison-title-row-cell comparison-title-row-cell--large-mobile'
            : 'comparison-title-row-cell';
          const titleCell = el(
            'th',
            {
              className: titleCellClassName,
              colspan: String(cols + 1),
              scope: 'rowgroup',
              role: 'rowheader',
            },
            row.title || ''
          );
          titleTr.appendChild(titleCell);
          tbody.appendChild(titleTr);
          continue;
        }

        const hasIconMobile = !!row.icon && row.showIconMobile !== false;
        const trClassName = [
          row.isPreTitle ? 'pre-title-row' : 'feature-row',
          row.isPreTitle && hasIconMobile ? 'pre-title-row--icon-mobile' : '',
        ].filter(Boolean).join(' ');
        const tr = el('tr', { role: 'row', className: trClassName });

        const rowHeaderClassName = (!row.icon && !row.title) ? 'row-header-cell row-header-cell--empty' : 'row-header-cell';
        const rowHeader = el('th', { scope: 'row', role: 'rowheader', className: rowHeaderClassName });
        const rowHeaderInner = el('div', { className: 'row-header' });
        if (row.icon) {
          const iconClassName = row.showIconMobile === false ? 'row-icon row-icon--hide-mobile' : 'row-icon';
          const iconSpan = el('span', { className: iconClassName });
          const iconNode = renderRowIcon(row.icon);
          if (iconNode) iconSpan.appendChild(iconNode);
          rowHeaderInner.appendChild(iconSpan);
        }
        const titleClassName = [
          'row-title',
          row.isPreTitle ? 'row-title--section' : '',
          row.largerFontMobile ? 'row-title--large-mobile' : '',
        ].filter(Boolean).join(' ');
        rowHeaderInner.appendChild(el('span', { className: titleClassName }, row.title || ''));
        rowHeader.appendChild(rowHeaderInner);
        tr.appendChild(rowHeader);

        let hasContent = false;
        const tds = [];
        for (let i = 0; i < cols; i++) {
          const td = el('td', { role: 'cell' });
          const { product, variantId } = getProductAndVariant(i);
          if (product) {
            const val = row.getValue(product, variantId);
            if (!isNodeEmpty(val)) hasContent = true;
            if (val instanceof Node) td.appendChild(val);
            else td.textContent = val;
          } else {
            td.textContent = '-';
          }
          tds.push(td);
        }

        tds.forEach(td => tr.appendChild(td));
        tbody.appendChild(tr);
      }
      return tbody;
    }

    function renderAsProductTable() {
      const wrapper = el('div', { className: 'prod-comparison-table' });
      const table = el('table', { role: 'table' });
      const thead = el('thead', { role: 'rowgroup' });
      const headerRow = el('tr', { role: 'row' });
      headerRow.appendChild(el('th', { scope: 'col', role: 'columnheader' }));

      for (let i = 0; i < columnCount(); i++) {
        const th = el('th', { scope: 'col', role: 'columnheader' });
        const headerContent = el('div', { className: 'product-header-content' });
        const sel = selectedFlatProducts[i];

        if (sel) {
          const imgContainer = el('div', { className: 'product-image-container' });
          const removeBtn = el('button', {
            className: 'remove-product-btn',
            'aria-label': 'Remove product',
            onClick() { selectFlatProduct('', i); },
          }, el('span', { innerHTML: VECTOR_SVG }));
          const img = el('img', {
            src: resolveImage(sel, sel.variantId),
            alt: sel.title,
            className: 'product-image',
          });
          imgContainer.appendChild(removeBtn);
          imgContainer.appendChild(img);
          headerContent.appendChild(imgContainer);
        }

        headerContent.appendChild(renderFlatProductSelector(i));
        if (sel) headerContent.appendChild(buildCta(sel, sel.variantId, showReviewSummary));
        th.appendChild(headerContent);
        headerRow.appendChild(th);
      }

      thead.appendChild(headerRow);
      table.appendChild(thead);

      const tbody = buildTbody(i => ({
        product: selectedFlatProducts[i],
        variantId: selectedFlatProducts[i]?.variantId,
      }));

      table.appendChild(tbody);
      wrapper.appendChild(table);
      return wrapper;
    }

    function renderFlatProductSelector(slotIndex) {
      const available = getAvailableFlatOptions(slotIndex);
      const sel = selectedFlatProducts[slotIndex];
      const currentVal = sel ? `${sel.productId}|||${sel.variantId}` : '';

      return createCustomSelect({
        value: currentVal,
        options: available.map(p => ({
          value: `${p.productId}|||${p.variantId}`,
          label: p.title,
        })),
        onChange(val) { selectFlatProduct(val, slotIndex); },
        placeholder: 'Select Product',
      });
    }

    /* ═══════════════════════════════════════════
      SELECTOR mode (product + variant dropdowns)
    ═══════════════════════════════════════════ */
    function getAvailableProducts(slotIndex) {
      return rawProducts.filter(p =>
        !selectedProducts.some((sel, i) => i !== slotIndex && sel && sel.productId === p.productId)
      );
    }

    function selectProduct(productId, slotIndex) {
      if (!productId) {
        selectedProducts[slotIndex] = null;
        selectedVariants[slotIndex] = null;
      } else {
        const prod = rawProducts.find(p => p.productId === productId);
        selectedProducts[slotIndex] = prod || null;
        selectedVariants[slotIndex] = prod?.variants?.[0]?.id || null;
      }
      persistState();
      render();
    }

    function selectVariant(variantId, slotIndex) {
      selectedVariants[slotIndex] = variantId;
      persistState();
      render();
    }

    function renderProductSelector(slotIndex) {
      const available = getAvailableProducts(slotIndex);
      const sel = selectedProducts[slotIndex];

      const container = el('div', { className: 'product-selector-container' });

      container.appendChild(createCustomSelect({
        value: sel?.productId || '',
        options: available.map(p => ({ value: p.productId, label: p.title })),
        onChange(val) { selectProduct(val, slotIndex); },
        placeholder: 'Select Product',
      }));

      if (sel && sel.variants && sel.variants.length > 1) {
        const variantSel = el('div', { className: 'variant-selector' });
        variantSel.appendChild(createCustomSelect({
          value: selectedVariants[slotIndex] || '',
          options: sel.variants.map(v => ({ value: v.id, label: v.title })),
          onChange(val) { selectVariant(val, slotIndex); },
          placeholder: 'Select Variant',
        }));
        container.appendChild(variantSel);
      }

      return container;
    }

    function renderSelectorTable() {
      const wrapper = el('div', { className: 'prod-comparison-table' });
      const table = el('table', { role: 'table' });
      const thead = el('thead', { role: 'rowgroup' });
      const headerRow = el('tr', { role: 'row' });
      headerRow.appendChild(el('th', { scope: 'col', role: 'columnheader' }));

      for (let i = 0; i < columnCount(); i++) {
        const th = el('th', { scope: 'col', role: 'columnheader' });
        const headerContent = el('div', { className: 'product-header-content' });
        const sel = selectedProducts[i];

        if (sel) {
          const imgContainer = el('div', { className: 'product-image-container' });
          const removeBtn = el('button', {
            className: 'remove-product-btn',
            'aria-label': 'Remove product',
            onClick() { selectProduct('', i); },
          }, el('span', { innerHTML: VECTOR_SVG }));
          const img = el('img', {
            src: resolveImage(sel, selectedVariants[i]),
            alt: sel.title,
            className: 'product-image',
          });
          imgContainer.appendChild(removeBtn);
          imgContainer.appendChild(img);
          headerContent.appendChild(imgContainer);
        }

        headerContent.appendChild(renderProductSelector(i));
        if (sel) headerContent.appendChild(buildCta(sel, selectedVariants[i], showReviewSummary));
        th.appendChild(headerContent);
        headerRow.appendChild(th);
      }

      thead.appendChild(headerRow);
      table.appendChild(thead);

      const tbody = buildTbody(i => ({
        product: selectedProducts[i],
        variantId: selectedVariants[i],
      }));

      table.appendChild(tbody);
      wrapper.appendChild(table);
      return wrapper;
    }

    initFromUrlOrStorage();
    render();

    window.matchMedia('(max-width: 768px)').addEventListener('change', render);
  }
}

customElements.define('product-comparison', ProductComparison);
}
